import createFolder from "./createFolder";
import getFileByPath from "./getFileByPath";
import createMedia from "./createMedia";
import createFile from "./createFile";
import defaultTree from "../../default_tree";

/**
 * @function bulkUpload
 * @param  {Array} files a promise that would resolve in returning files
 * @param  {boolean} uploadOnlyNewFiles
 * @return {type} {description}
 */
async function bulkUpload(files, uploadOnlyNewFiles, feedbackLog = () => {}) {
  for (let index = 0; index < files.length; index = index + 5) {
    const entries = files.filter((_, idx) => idx >= index && idx < index + 5);
    const promises = entries.map(async file => {
      const shouldIgnoreFile = uploadOnlyNewFiles && getFileByPath(file.path);
      file.reference = CodeEditor.Main.generateReference(file.path);
      file.file_type = CodeEditor.Main.fileType(file.path);
      if (shouldIgnoreFile || pathExistsInTree(defaultTree, file.path)) return console.warn(`ignoring ${file.path}`);
      if (file.path.endsWith("/")) {
        const path = file.path.slice(0, -1);
        try {
          await createFolder(file, path);
          feedbackLog(`✅ Created folder "${path}"`);
        } catch (error) {
          feedbackLog(`❌failed creating folder ${path}`);
        }
      } else {
        const nodeName = file.path.split("/").last();
        const nodePath = getDirectoryPath(file.path);
        const folderOrImages = nodePath.match(/assets\/images|assets\/fonts/);
        if (folderOrImages) {
          const folderReference = nodePath.slice(folderOrImages.index + 7, nodePath.length);
          if (!folderReference) return;
          await createMedia(file, nodePath, folderReference);
        } else {
          feedbackLog(`Creating "${nodeName}" at "${nodePath}"`);
          const { success } = await createFile(file);
          if (success) feedbackLog(`✅ Successfully added ${file.reference} to ${file.path} ✅`);
          else feedbackLog(`❌ Failed adding ${file.reference} to ${file.path} ❌`);
        }
      }
    });
    await Promise.all(promises);
    console.log(`Left ${files.length} - ${index} = ${files.length - index}`);
  }
}

export default bulkUpload;

function getDirectoryPath(path) {
  return path
    .split("/")
    .slice(0, -1)
    .join("/");
}

function pathExistsInTree({ tree }, path) {
  const finder = i => i.path === path || (i.children && i.children.some(finder));
  console.log(path);
  return tree.some(finder);
}
